module.exports = __webpack_public_path__ + "static/media/PV.4ae41691.svg";